import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { ClaseContrato } from '../models/claseContrato';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/claseContratos';

@Injectable({
  providedIn: 'root'
})
export class ClaseContratoService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getByPais(pais): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetByPais?paisid=' + pais })
  }

  save(claseContrato: ClaseContrato)
  {
    return this._http.post({ url: baseUrl + '/Save', body: claseContrato });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });   
  }
}

